import type React from 'react'
import type { ComponentProps } from 'react'
import type { RestaurantMainInfo, RestaurantSubInfo } from '~/features/info/RestaurantInfo'

type RestaurantMainInfoShowTypes = React.ComponentProps<typeof RestaurantMainInfo>['showTypes']
type RestaurantSubInfoShowTypes = React.ComponentProps<typeof RestaurantSubInfo>['showTypes']
type ViewType = 'guide' | 'planModal' | 'planPage'

export type GuideInfoRestaurant = ComponentProps<typeof RestaurantMainInfo>['restaurant'] &
  ComponentProps<typeof RestaurantSubInfo>['restaurant']

export type Props = {
  restaurant: GuideInfoRestaurant
  viewType?: ViewType
  className?: string
}

export function mainShowTypes(viewType: ViewType) {
  const types: RestaurantMainInfoShowTypes = new Set()
  if (viewType === 'guide') {
    types.add('map')
    types.add('cancelPolicy')
  }
  if (viewType !== 'planModal') {
    types
      .add('name')
      .add('address')
      .add('access')
      .add('phoneNumber')
      .add('openingHours')
      .add('regularHoliday')
  }
  return types
}
if (import.meta.vitest) {
  const { describe, expect, test } = import.meta.vitest
  describe('mainShowTypes', () => {
    test('viewType が guide', () => {
      expect(mainShowTypes('guide')).toStrictEqual(
        new Set([
          'map',
          'cancelPolicy',
          'name',
          'address',
          'access',
          'phoneNumber',
          'openingHours',
          'regularHoliday',
        ])
      )
    })
    test('viewType が planModal', () => {
      expect(mainShowTypes('planModal')).toStrictEqual(new Set([]))
    })
    test('viewType が planPage', () => {
      expect(mainShowTypes('planPage')).toStrictEqual(
        new Set(['name', 'address', 'access', 'phoneNumber', 'openingHours', 'regularHoliday'])
      )
    })
  })
}

export function subShowTypes(viewType: ViewType) {
  const types: RestaurantSubInfoShowTypes = new Set()
  if (viewType === 'guide') {
    types.add('notes')
  }
  if (viewType !== 'planModal') {
    types.add('seats').add('parking')
  }
  return types
}
if (import.meta.vitest) {
  const { describe, expect, test } = import.meta.vitest
  describe('subShowTypes', () => {
    test('viewType が guide', () => {
      expect(subShowTypes('guide')).toStrictEqual(new Set(['notes', 'seats', 'parking']))
    })
    test('viewType が planModal', () => {
      expect(subShowTypes('planModal')).toStrictEqual(new Set([]))
    })
    test('viewType が planPage', () => {
      expect(subShowTypes('planPage')).toStrictEqual(new Set(['seats', 'parking']))
    })
  })
}
